import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=6f22a5c7&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=6f22a5c7&prod&lang=scss&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=6f22a5c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22a5c7",
  null
  
)

export default component.exports